import { render } from "./ProdList.vue?vue&type=template&id=82845ed6"
import script from "./ProdList.vue?vue&type=script&lang=js"
export * from "./ProdList.vue?vue&type=script&lang=js"

import "./ProdList.vue?vue&type=style&index=0&id=82845ed6&lang=css"

import exportComponent from "E:\\OpenServer\\domains\\vue\\vue-catalog\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__